import {
  MyApprovalRequestsTableFieldsFragment,
  Maybe,
  ApprovalRequestStatus,
  AbsenceApprovalStatus,
} from '../../../__generated__/graphql';
import { mapApprover } from '../../Absences/MyAbsences/mappings';
import { Approver } from '../../Absences/MyAbsences/MyAbsenceFilters/types';

export type ApprovalRequestTableItem = {
  id: string;
  name: string;
  employee: {
    id: string;
    name: string;
    avatarUrl: Maybe<string>;
  };
  approvalStatus: ApprovalRequestStatus;
  actionDatetime: Maybe<string>;
  relatedRecordId: string;
  relatedRecordApiName: string;
  relatedRecordName: string;
  relatedRecordObjectName: string;
  requestedAt: string;
  approverComment: Maybe<string>;
  description: Maybe<string>;
  approver?: Maybe<Approver>;
  lastModifiedDate?: string;
  actions: string;
  absence?: Maybe<{
    Id: string;
    flair__Approval_Status__c: AbsenceApprovalStatus;
  }>;
};

export const mapApprovalRequests = (
  src: ReadonlyArray<MyApprovalRequestsTableFieldsFragment>,
): ApprovalRequestTableItem[] => {
  return src.map((item) => ({
    id: item.Id,
    name: item.Name,
    employee: {
      id: item.recordEmployee?.Id ?? '',
      name: item.recordEmployee?.Name ?? '',
      avatarUrl: item.recordEmployee?.avatar?.url ?? null,
    },
    approvalStatus: item.flair__Approval_Status__c,
    actionDatetime: item.flair__Action_Datetime__c,
    relatedRecordId: item.flair__Related_Id__c,
    relatedRecordApiName: item.flair__Related_Object_Name__c,
    relatedRecordName: item.relatedRecordName ?? '',
    relatedRecordObjectName: item.relatedRecordObjectName,
    requestedAt: item.flair__Requested_At__c,
    approverComment: item.flair__Approver_Comment__c,
    description: item.flair__Short_Description__c,
    approver: item.approver ? mapApprover(item.approver) : null,
    lastModifiedDate: item.LastModifiedDate,
    actions: '',
    absence: item.absence
      ? {
          Id: item.absence.Id,
          flair__Approval_Status__c: item.absence.flair__Approval_Status__c,
        }
      : null,
  }));
};
